import cn from "classnames"
import React from "react"

import { Heading, HeadingProps } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"

import styles from "./index.module.css"

export const HeadingWithLink: React.FC = ({ children }) => (
  <div className={styles.Head}>{children}</div>
)

export const HeadingLink: React.FC<{ className?: string } & JSX.IntrinsicElements["a"]> = ({
  children,
  className,
  href,
}) => (
  <div className={cn(styles.Link, className)}>
    <Link href={href} view="arrow">
      {children}
    </Link>
  </div>
)

type HeadingTitleType = {
  like?: HeadingProps["like"]
  as?: HeadingProps["as"]
  className?: string
}
export const HeadingTitle: React.FC<HeadingTitleType> = ({
  children,
  like = "h1",
  as = "h2",
  className,
}) => (
  <Heading as={as} className={cn(styles.Title, className)} like={like}>
    {children}
  </Heading>
)
